const GoogleMap = (mapEl) => {

	let lat = parseFloat(mapEl.getAttribute('data-lat'));
	let lng = parseFloat(mapEl.getAttribute('data-lng'));
	const address = mapEl.getAttribute('data-address');

	if(!address && !lat && !lng) {
		lat = parseFloat(mapEl.getAttribute('data-lat-backup'));
		lng = parseFloat(mapEl.getAttribute('data-lng-backup'));
	}

	if(!address && !lat && !lng) {
		return;
	}

	const initMapAndMarker = ({lat, lng}) => {

		const options = {
			zoom: ( mapEl.getAttribute('data-zoom') ? parseInt(mapEl.getAttribute('data-zoom')) : 14 ),
			center: { lat, lng },
			streetViewControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			disableDefaultUI: true,
		}
		const map = new google.maps.Map(mapEl, options);

		new google.maps.Marker({
			map: map,
			position: { lat, lng },
			label: {
				text: mapEl.getAttribute('data-marker-label') ? mapEl.getAttribute('data-marker-label') : '',
				className: 'svitzer21-google-map-marker',
			},
		});
	};

	// If we have lat + lng, then use them...
	if(lat && lng) {
		initMapAndMarker({lat, lng});
	}
	// ... otherwise geocode the address
	else {

		let geocoder = new google.maps.Geocoder();
		geocoder.geocode({
			'address': address,
		}, (results, status) => {
			if(status === google.maps.GeocoderStatus.OK) {
				initMapAndMarker({
					lat: results[0].geometry.location.lat(),
					lng: results[0].geometry.location.lng(),
				});
			}
		});
	}

};

export default GoogleMap;